import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./Home/Home";
import Header from "./Base/Header";
import Terms from "./Terms/Terms";
import Privacy from "./Terms/Privacy";
import Consumer from "./Terms/Consumer";
import AccessibilityIcon from "./Base/AccessibilityIcon";

export default function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <Header />
      <main className="main">
        <Routes>
          <Route path="" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/consumer-health-data" element={<Consumer />} />
        </Routes>
      </main>
      <AccessibilityIcon />
    </>
  );
}
